// extracted by mini-css-extract-plugin
export var label = "_js-2";
export var slideContainer = "_js-0";
export var slider = "_js-1";